"use strict";
/***********************************************************************************
 * This file makes use of == and != to reduce the number of comparisons being done *
 * https://jsbench.me/j9lb449aak                                                   *
 ***********************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.not = exports.makeUnionLitteralPredicate = exports.makeValuesPredicate = exports.isNonEmptyObject = exports.isEmptyObject = exports.isNonEmpty = exports.isEmpty = exports.isString = exports.isEmptyOrNotDefined = exports.isDefinedAndNotEmpty = exports.isDefinedAndNonEmpty = exports.isNotDefined = exports.isDefined = void 0;
/**
 * Check if parameter `x` is defined
 * @param x a nullable value
 * @returns `false` if it's null or undefined, `true` otherwise
 */
function isDefined(x) {
    return x != null;
}
exports.isDefined = isDefined;
/**
 * Check if parameter `x` is not defined
 * @param x a nullable value
 * @returns `true` if it's null or undefined, `false` otherwise
 */
function isNotDefined(x) {
    return x == null;
}
exports.isNotDefined = isNotDefined;
function isDefinedAndNonEmpty(x) {
    // When x is not an array or a string, x.length === undefined so this will return true
    return x != null && x.length !== 0;
}
exports.isDefinedAndNonEmpty = isDefinedAndNonEmpty;
/**
 * Check if parameter `x` is defined and not empty
 * @param x a nullable string or array
 * @returns `false` if it's null or undefined or empty, `true` otherwise
 * @deprecated Use {@link isDefinedAndNonEmpty} instead
 */
exports.isDefinedAndNotEmpty = isDefinedAndNonEmpty;
function isEmptyOrNotDefined(x) {
    return x == null || x.length === 0;
}
exports.isEmptyOrNotDefined = isEmptyOrNotDefined;
/**
 * Check if parameter `x` is a string
 * @param x any value
 * @returns `true` if it's a string, `false` otherwise
 */
function isString(x) {
    return typeof x === 'string';
}
exports.isString = isString;
function isEmpty(x) {
    return x.length === 0;
}
exports.isEmpty = isEmpty;
function isNonEmpty(x) {
    return x.length !== 0;
}
exports.isNonEmpty = isNonEmpty;
/**
 * Check if parameter object is empty
 * @param x an object (not an array)
 * @returns `true` if it's empty, `false` otherwise
 */
function isEmptyObject(x) {
    // https://stackoverflow.com/a/59787784/1654241 solution A
    for (const _key in x) {
        return false;
    }
    return true;
}
exports.isEmptyObject = isEmptyObject;
/**
 * Check if parameter `x` is non empty
 * @param x an object
 * @returns `false` if it's empty, `true` otherwise
 */
function isNonEmptyObject(x) {
    // https://stackoverflow.com/a/59787784/1654241 solution A
    for (const _key in x) {
        return true;
    }
    return false;
}
exports.isNonEmptyObject = isNonEmptyObject;
/**
 * Higher Order function which return a values predicate
 * @param values Array of all the possible values that the predicate should match
 * @returns A type predicate for the values. If `values` is a tuple, the predicate will make Typescript infer this type when true.
 *
 * Calling this function is O(n) and consumes a bit of memory for the lookup table
 */
function makeValuesPredicate(values) {
    const lookupTable = values.reduce((acc, curr) => {
        acc[curr] = true;
        return acc;
    }, {});
    /**
     * Values predicate
     * @param value a nullable string value
     * @returns `true` if `value` is among the values passed to create this predicate, `false` otherwise
     *
     * Calling this function is O(1)
     */
    return function isInValues(value) {
        var _a;
        return (_a = (value != null && lookupTable[value])) !== null && _a !== void 0 ? _a : false;
    };
}
exports.makeValuesPredicate = makeValuesPredicate;
/**
 * Higher Order function which return a litteral union type predicate
 * @param allEnumValues Const array of all the union type litteral values
 * @returns A type predicate for the litteral union type
 * @deprecated Use {@link makeValuesPredicate} directly
 */
exports.makeUnionLitteralPredicate = makeValuesPredicate;
function not(predicate) {
    return function inversePredicate(arg) {
        return !predicate(arg);
    };
}
exports.not = not;
//# sourceMappingURL=predicates.js.map